import React from 'react';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import DataExtractorViewer from 'components/DataExtractorViewer';
import PageIntro from 'components/PageIntro';
import { Button, Typography } from 'design-component';
import { palette } from 'styles/color';
import FileButton from 'components/FileButton';
import { Trans, useTranslation } from 'react-i18next';
import ga, { EventOpenSample, EventUpload } from 'util/gaConnect';
import { SAMPLE_FILE_DATA } from 'data/sample';
import { IconUpload } from 'assets/icon';
import { useAppSelector } from 'store/store';
import { userInfoSelector } from 'store/slices/userInfo';
import { languageSelector } from 'store/slices/languageSlice';
import { StlyedLink } from 'pages/Api/Usage';
// import { apiWrapper } from 'api';
// import { unzip, ZipEntry } from 'unzipit';

type DocumentTypes = 'hwp' | 'word' | 'slide' | 'sheet' | 'pdf';
export type SampleType = DocumentTypes | 'upload';
export type JsonType = 'unified' | 'full';

const DocExtractor = () => {
  // const userInfo = useAppSelector(userInfoSelector);
  const { t } = useTranslation();
  const { isLogged } = useAppSelector(userInfoSelector);
  const lang = useAppSelector(languageSelector);
  const [file, setFile] = useState<File>();
  const [selectedType, setSelectedType] = useState<SampleType>(lang === 'ko' ? 'hwp' : 'word');
  const [sampleData, setSampleData] = useState<any>(null);
  // const [sampleType, setSampleType] = useState<(typeof SampleTypes)[number] | null>(null);
  const [schemaType, setSchemaType] = useState<JsonType>('unified');

  const clearSampleData = () => {
    setSampleData(null);
    setFile(undefined);
    setSelectedType('upload');
  };

  const handleSelectType = (type: SampleType) => {
    if (type === selectedType) return;
    setSchemaType('unified');
    setFile(undefined);
    setSampleData(null);
    setSelectedType(type);
  };

  const onOpenSample = (type: SampleType) => {
    if (type === 'upload') {
      setSampleData(null);
    } else {
      try {
        // NOTE: 압축 폴더에서 샘플 파일을 불러오는 방식
        // const resource = await fetch(`/public/sampleZip/${type}-sample.zip`);

        // const blob = await resource.blob();
        // const zip = await unzip(blob); // unzipit 라이브러리 사용
        // const jsonEntry = zip.entries['data.zip'];
        // const imageEntry = zip.entries['image.zip'];
        // if (!jsonEntry || !imageEntry) throw new Error();

        // const extractDataEntry = (entry: ZipEntry): Promise<any> => {
        //   return new Promise(async (resolve, reject) => {
        //     const blob = await entry.blob();
        //     //setResFileBlob(blob);
        //     const data = await unzip(blob);

        //     // json 데이터 추출
        //     const jsonEntry = Object.values(data.entries).find((entry) =>
        //       entry.name.endsWith('.json')
        //     );
        //     if (!jsonEntry) reject();
        //     const json = JSON.parse(await jsonEntry!.text());

        //     // 이미지 데이터 추출
        //     const imageEntries = Object.values(data.entries).filter(
        //       (entry) => entry.name.match(/\.(png|jpg|jpeg|gif)$/i) // 이미지 파일 필터링
        //     );

        //     const images = await Promise.all(
        //       imageEntries.map(async (entry) => {
        //         const fileName = entry.name; // 파일명
        //         const blob = await entry.blob(); // Blob 생성
        //         const correctedBlob = new Blob([blob], { type: 'image/png' }); // MIME 타입 강제 설정
        //         const url = URL.createObjectURL(correctedBlob);
        //         return { fileName, url };
        //       })
        //     );

        //     resolve({
        //       json, // JSON 데이터
        //       images // 이미지 데이터
        //     });
        //   });
        // };

        // const extractImageEntry = (entry: ZipEntry): Promise<any> => {
        //   return new Promise(async (resolve, reject) => {
        //     const blob = await entry.blob();
        //     const image = await unzip(blob);

        //     const response = await Promise.all(
        //       Object.values(image.entries).map((entry) => {
        //         const index = parseInt(entry.name.split('_')[1].split('.')[0]);

        //         return new Promise<{ index: number; content: string }>(async (resolve) => {
        //           const blob = await entry.blob();
        //           const reader = new FileReader();
        //           reader.onloadend = (e) => {
        //             resolve({ index, content: e.target?.result as string });
        //           };
        //           reader.onerror = (e) => {
        //             reject(e);
        //           };
        //           reader.readAsDataURL(blob);
        //         });
        //       })
        //     );
        //     const images = response.sort((a, b) => a.index - b.index);

        //     resolve({
        //       images: images.map((image) => image.content)
        //     });
        //   });
        // };

        // const [extractedData, extractedThumbnail] = await Promise.all([
        //   extractDataEntry(jsonEntry),
        //   extractImageEntry(imageEntry)
        // ]);

        // const result = {
        //   json: extractedData,
        //   pageimages: extractedThumbnail.images
        // };

        // setSampleData(result);
        // setSampleData(SAMPLE_FILE_DATA[type as keyof typeof SAMPLE_FILE_DATA]);
        setSampleData(SAMPLE_FILE_DATA(lang)[type]);
        ga.event(EventOpenSample(type));
      } catch (e) {
        console.error('Error in handleSelectType:', e);
      }
    }
  };

  useEffect(() => {
    onOpenSample(selectedType as SampleType);
  }, [selectedType, file, lang]);

  useEffect(() => {
    if (!isLogged) {
      setFile(undefined);
    }
    setSelectedType(lang === 'ko' ? 'hwp' : 'word');
  }, [isLogged, lang]);

  const getDocumentTypes = ({
    lang,
    _types
  }: {
    lang: 'ko' | 'en';
    _types: DocumentTypes[];
  }): DocumentTypes[] => {
    return lang === 'ko' ? _types : ['word', 'slide', 'sheet', 'pdf', 'hwp'];
  };

  return (
    <PlayGroundBase>
      <PageIntro title={t('docExtract')}>
        <Typography size="16px" weight={'normal'} color={palette.gray[500]}>
          {t('docExtractDesc')}
        </Typography>
        <Typography
          size="16px"
          weight={'normal'}
          color={palette.gray[500]}
          style={{
            fontStyle: 'italic',
            marginTop: '-8px'
          }}>
          <Trans
            i18nKey="betaDesc"
            components={{
              1: (
                <StlyedLink
                  to={
                    lang === 'ko'
                      ? 'mailto:sales@polarisoffice.com '
                      : 'mailto:globalsales@polarisoffice.com'
                  }
                />
              )
            }}
          />
        </Typography>
      </PageIntro>
      <Typography
        size="18px"
        weight={500}
        color={palette.gray[800]}
        style={{ margin: '28px 0px 12px 0px' }}>
        {t('selectSampleFile')}
      </Typography>
      <Toolbar>
        <>
          {getDocumentTypes({ lang, _types: ['hwp', 'word', 'slide', 'sheet', 'pdf'] }).map(
            (type) => (
              <FileButton
                key={type}
                type={type}
                onClick={() => handleSelectType(type)}
                style={{
                  color: selectedType === type ? palette.blue[500] : palette.gray[800],
                  border: `1px solid ${
                    selectedType === type ? palette.blue[500] : palette.gray[200]
                  }`,
                  background: selectedType === type ? palette.white : 'initial'
                }}></FileButton>
            )
          )}
        </>
        <Button
          disabled={schemaType === 'full'}
          variant="outlined"
          color="primary"
          startIcon={<IconUpload />}
          onClick={() => handleSelectType('upload')}
          // 활성 정보 prop

          style={{
            color: selectedType === 'upload' ? palette.blue[500] : palette.gray[800],
            border: `1px solid ${
              selectedType === 'upload' ? palette.blue[500] : palette.gray[200]
            }`,
            background: selectedType === 'upload' ? palette.white : 'initial'
          }}>
          {t('upload')}
        </Button>
        {/* <UploadButton
          onClick={(e) => {
            if (!userInfo.isLogged) {
              e.preventDefault();
              e.stopPropagation();
              apiWrapper(`/api/v1/datainsight/playground/userinfo`);
            }
            ga.event(EventUpload);
          }}
          onChange={(file) => setFile(file)}></UploadButton> */}
      </Toolbar>
      <DataExtractorViewer
        file={file}
        setFile={setFile}
        sampleData={sampleData}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        clearSampleData={clearSampleData}
        schemaType={schemaType}
        setSchemaType={setSchemaType}></DataExtractorViewer>
    </PlayGroundBase>
  );
};

export default DocExtractor;

const PlayGroundBase = styled.div`
  width: 100%;
  // height: 100%;
  display: flex;
  flex-direction: column;
`;
const Toolbar = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;

  margin-bottom: 19px;
`;
